import { combineReducers } from 'redux';
// Import reducers
import form from './cognito_form_reducer';
import tree from './cognito_tree_reducer';
import files from './cognito_files_reducer';

export default combineReducers({ form, tree, files });
